<template>
  <v-container>
    <div v-if="messages">
      <div class="pa-4">
        <span>{{ $t('dash.messageConfiguration.welcomeMessage') }}</span>
        <v-text-field
          v-model="messages.onWelcome.title"
          outlined
          :label="$t('dash.messageConfiguration.title')"
          class="pa-0"
        ></v-text-field>
        <neoparent-tiptap
          :content="messages.onWelcome.message"
          type="onWelcome"
          class="pt-0 pb-6 mb-6"
        ></neoparent-tiptap>
      </div>

      <v-divider></v-divider>

      <div class="pa-4">
        <span>{{ $t('dash.messageConfiguration.deceasedMessage') }}</span>
        <v-text-field
          v-model="messages.onDeceased.title"
          outlined
          :label="$t('dash.messageConfiguration.title')"
          class="pa-0"
        ></v-text-field>
        <neoparent-tiptap
          :content="messages.onDeceased.message"
          type="onDeceased"
          class="pt-0 pb-6 mb-6"
        ></neoparent-tiptap>
      </div>

      <v-divider></v-divider>

      <div class="pa-4">
        <span>{{ $t('dash.messageConfiguration.dismissalMessage') }}</span>
        <v-text-field
          v-model="messages.onDismissal.title"
          outlined
          :label="$t('dash.messageConfiguration.title')"
          class="pa-0"
        ></v-text-field>
        <neoparent-tiptap
          :content="messages.onDismissal.message"
          type="onDismissal"
          class="pt-0 pb-6 mb-6"
        ></neoparent-tiptap>
      </div>

      <v-divider></v-divider>

      <div class="pa-4">
        <span>{{ $t('dash.messageConfiguration.reSubmitMessage') }}</span>
        <v-text-field
          v-model="messages.onReSubmit.title"
          outlined
          :label="$t('dash.messageConfiguration.title')"
          class="pa-0"
        ></v-text-field>
        <neoparent-tiptap
          :content="messages.onReSubmit.message"
          type="onReSubmit"
          class="pt-0 pb-6 mb-6"
        ></neoparent-tiptap>
      </div>
    </div>

    <v-btn @click="save" primary>Save</v-btn>
  </v-container>
</template>

<script>
import { neoparentHospital } from "@/api";

export default {
  name: "neoparent-message-configuration",
  data() {
    return {
      messages: null,
      hospital: null
    };
  },
  async mounted() {
    const that = this
    const tmp = await neoparentHospital.getHospitalInfo();
    this.hospital = tmp.data.hospital;

    this.messages = this.hospital.hospitalDefaultMessages

    if (!this.messages) {
      this.messages = {
          onWelcome: {},
          onDeceased: {},
          onDismissal: {},
          onReSubmit: {}
      }
    }

    this.$root.$on('mediligo-markdown-editor-save', (data) => {
      that.messages[data.type].message = data.content;
    });
  },
  components: {},
  methods: {
    save() {
      neoparentHospital.editHospitalMessages(this.messages)
        .then(() => {
          this.redirect("/dashboard");
        })
    }
  }
}
</script>

<style lang="css" scoped>

</style>
